import { useEffect, useState } from "react";
import { Card, Col, Row, Button, Dropdown } from "react-bootstrap";
import NoData from "../../../common/NoData";
import "./style.scss";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import { Table } from "reactstrap";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import Pagination from "../../../common/Pagination/Pagination";
import AttendanceService from "../../../../services/HRM/AttendanceService";
import Select from "react-select";
import ScrollPagination from "../../../Enums/ScrollPagination";
import BranchesService from "../../../../services/Company/BranchesService";
import DepartmentService from "../../../../services/Company/DepartmentService";
import MonthDropDown, { months } from "../../../Enums/MonthDropDown";
import YearDropDown from "../../../Enums/YearDropDown";
import EditAttendanceModal from "./EditAttendanceModal";
import FingerprintSettings from "./FingerprintSettings";
import FingerprintExclusion from "./FingerprintExclusion";
import UploadSheetModal from "./UploadSheetModal";
import { ExportExcel, ExportPdf } from "../../../Enums/Export";
import { toast } from "react-toastify";

const Attendance = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [addModal, setAddModal] = useState(false);
	const [modal, setModal] = useState(false);
	const [item, setItem] = useState({});
	const [filters, setFilters] = useState({
		type: "",
		date: "",
		month: "",
		year: "",
		branchId: "",
		mainBranch: null,
		departmentId: "",
		search: "",
		dateFrom: "",
		dateTo: "",
	});
	const [params, setParams] = useState({});
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [uploadSheetModal, setUploadSheetModal] = useState(false);
	const [total, setTotal] = useState(0);
	const [downloading, setDownloading] = useState(false);
	const attendanceService = new AttendanceService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const types = [
		{ value: "daily", label: Translate[lang]?.daily },
		{ value: "monthly", label: Translate[lang]?.monthly },
	];
	const [selectTab, setSelectTab] = useState("attendance");
	const [selectSubTab, setSelectSubTab] = useState("exclude_from_fingerprint");
	const mainTabs = ["attendance", "fingerprint_settings"];
	const subTabs = ["exclude_from_fingerprint", "fingerprint_settings"];

	useEffect(() => {
		let newParams = {};
		if (!!filters?.type) newParams.type = filters.type.value;
		if (!!filters?.date) newParams.date = filters.date;
		if (!!filters?.month)
			newParams.month = months?.findIndex((m) => m === filters.month.value) + 1;

		if (!!filters?.year) newParams.year = filters.year.value;
		if (!!filters?.branchId)
			newParams.branchId = filters.branchId.id || filters.branchId.value;
		if (
			filters?.mainBranch &&
			filters?.mainBranch?.value !== undefined &&
			filters?.mainBranch?.value !== null
		) {
			newParams.mainBranch = filters.mainBranch.value;
		}
		if (!!filters?.departmentId)
			newParams.departmentId =
				filters.departmentId.id || filters.departmentId.value;
		if (!!filters?.search) newParams.search = filters.search;
		if (!!filters?.dateFrom) newParams.dateFrom = filters.dateFrom;
		if (!!filters?.dateTo) newParams.dateTo = filters.dateTo;
		setParams(newParams);
		setShouldUpdate((prev) => !prev);
	}, [filters]);

	const extractTime = (isoString) => {
		if (!isoString) return "N/A";
		return new Date(isoString).toLocaleTimeString("en-US", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: true,
		});
	};

	const handleDownloadReport = async (format) => {
		if (!total) {
			toast.error(Translate[lang]?.no_data ?? "No data to download");
			return;
		}
		setDownloading(true);
		try {
			const limit = 25;
			const totalPages = Math.ceil(total / limit);
			console.log("Total Pages:", total, totalPages);
			// fetch every page (1..totalPages) and collect all rows
			const requests = [];
			for (let page = 1; page <= totalPages; page++) {
				requests.push(attendanceService.getList({ page, limit, ...params }));
			}
			const responses = await Promise.all(requests);

			const rows = responses.reduce((acc, res) => {
				if (res?.status === 200) {
					acc.push(...(res?.data?.data?.data ?? []));
				}
				return acc;
			}, []);

			if (!rows.length) {
				toast.error(Translate[lang]?.no_data ?? "No data to download");
				return;
			}

			const parseDateToTime = (dateStr) => {
				if (!dateStr) return 0;
				const parsed = Date.parse(dateStr);
				if (!isNaN(parsed)) return parsed;

				const parts = String(dateStr).split(/[/.-]/);
				if (parts.length === 3) {
					if (parts[2].length === 4) {
						const d = new Date(parts[2], parts[1] - 1, parts[0]);
						return d.getTime() || 0;
					}
					if (parts[0].length === 4) {
						const d = new Date(parts[0], parts[1] - 1, parts[2]);
						return d.getTime() || 0;
					}
				}
				return 0;
			};

			// Sort rows: first by employee name, then by employee ID, then chronologically by date (oldest to newest)
			const sortedRows = [...rows].sort((a, b) => {
				const nameA = (a?.employeeName || "").trim();
				const nameB = (b?.employeeName || "").trim();
				const nameComp = nameA.localeCompare(nameB, lang || "en", {
					sensitivity: "base",
				});
				if (nameComp !== 0) return nameComp;

				const idA = String(a?.employeeId ?? "");
				const idB = String(b?.employeeId ?? "");
				const idComp = idA.localeCompare(idB);
				if (idComp !== 0) return idComp;

				const timeA = parseDateToTime(a?.date);
				const timeB = parseDateToTime(b?.date);
				if (timeA !== timeB) return timeA - timeB;

				const clockInA = a?.clockInTime ? Date.parse(a.clockInTime) : 0;
				const clockInB = b?.clockInTime ? Date.parse(b.clockInTime) : 0;
				return (clockInA || 0) - (clockInB || 0);
			});

			const exportData = sortedRows.map((item) => ({
				[Translate[lang]?.id ?? "I.D"]: item?.employeeId,
				[Translate[lang]?.name ?? "Name"]: item?.employeeName,
				[Translate[lang]?.company_email ?? "Company Email"]: item?.companyEmail,
				[Translate[lang]?.branch ?? "Branch"]: item?.branches
					?.map((b) => b?.branchName?.[lang])
					?.join(", "),
				[Translate[lang]?.date ?? "Date"]: item?.date,
				[Translate[lang]?.clockIn ?? "Clock In"]: extractTime(
					item?.clockInTime,
				),
				[Translate[lang]?.clockOut ?? "Clock Out"]: extractTime(
					item?.clockOutTime,
				),
				[`${Translate[lang]?.clockIn ?? "Clock In"} ${Translate[lang]?.branch ?? "Branch"}`]:
					item?.branchName?.[lang] ??
					item?.branchName?.name ??
					item?.branchName ??
					"-",
				[`${Translate[lang]?.clockOut ?? "Clock Out"} ${Translate[lang]?.branch ?? "Branch"}`]:
					item?.clockOutBranchName?.[lang] ??
					item?.clockOutBranchName?.name ??
					item?.clockOutBranchName ??
					"-",
				[Translate[lang]?.late_minutes ?? "Late Minutes"]: item?.lateMinutes,
				[Translate[lang]?.overtime_minutes ?? "Overtime Minutes"]:
					item?.overtimeMinutes,
				[Translate[lang]?.early_leaving_minutes ?? "Early Leaving Minutes"]:
					item?.earlyLeavingMinutes,
				[Translate[lang]?.status ?? "Status"]:
					Translate[lang]?.[item?.status?.toLowerCase()] ?? item?.status,
			}));

			if (format === "pdf") {
				ExportPdf(
					exportData,
					"Attendance Report.pdf",
					`${Translate[lang]?.attendance ?? "Attendance"} ${Translate[lang]?.report ?? "Report"}`,
				);
			} else {
				ExportExcel(exportData, "Attendance Report.xlsx");
			}
		} finally {
			setDownloading(false);
		}
	};

	return (
		<div className="admin">
			<div className="search-card d-flex justify-content-between align-items-center">
				<div className="custom-tabs-div px-0">
					{mainTabs?.map((tab, index) => {
						return (
							<p
								key={index}
								className={`${tab === selectTab ? "activeP" : ""}`}
								onClick={() => setSelectTab(tab)}>
								{Translate[lang][tab]}
							</p>
						);
					})}
				</div>
				{selectTab === "fingerprint_settings" && (
					<div className="d-flex gap-8">
						<Button
							variant="primary"
							onClick={() => setUploadSheetModal(true)}
							className="me-2">
							<i className="la la-download mx-1"></i>
							{Translate[lang]?.upload_fingerprint_report}
						</Button>
					</div>
				)}
			</div>
			{selectTab === "fingerprint_settings" && (
				<div className="tabs-div px-0 mt-3">
					{subTabs?.map((tab, index) => {
						return (
							<p
								key={index}
								className={`${tab === selectSubTab ? "activeP" : ""}`}
								onClick={() => setSelectSubTab(tab)}>
								{Translate[lang][tab]}
							</p>
						);
					})}
				</div>
			)}
			{(selectTab === "attendance" ||
				selectSubTab === "fingerprint_settings") && (
				<div className="mb-3 search-card d-flex justify-content-between py-3 align-items-center">
					<span
						style={{
							fontWeight: "600",
							textTransform: "capitalize",
							color: "#000",
						}}>
						{selectTab === "attendance"
							? Translate[lang].attendance
							: Translate[lang][selectSubTab]}
					</span>

					{/* {isExist("add_loans") && selectTab === "has_loans" && ( */}
					{selectTab === "attendance" && (
						<div className="d-flex gap-8">
							{/* <Button
								variant="outline-primary"
								className="px-2 fs-20 py-1 h-75"
								onClick={() => {
									setModal(true);
								}}>
								<i className="la la-filter"></i>
							</Button> */}
							<Dropdown>
								<Dropdown.Toggle
									variant="primary"
									className="me-2"
									disabled={downloading || !total}>
									<i className="la la-download mx-1"></i>
									{downloading
										? (Translate[lang]?.loading ?? "Loading...")
										: `${Translate[lang]?.download} ${Translate[lang]?.report}`}
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item onClick={() => handleDownloadReport("excel")}>
										<i className="la la-file-excel-o mx-1"></i>
										{Translate[lang]?.excel ?? "Excel"}
									</Dropdown.Item>
									<Dropdown.Item onClick={() => handleDownloadReport("pdf")}>
										<i className="la la-file-pdf-o mx-1"></i>
										{Translate[lang]?.pdf ?? "PDF"}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					)}
					{/* )} */}
				</div>
			)}

			{selectTab === "attendance" && (
				<Card className="mb-3">
					<Card.Header className="px-2">
						<Row className="w-100">
							<Col md={3} className="mb-3">
								<label>Branch</label>
								<ScrollPagination
									Service={new BranchesService()}
									value={filters?.branchId}
									nameVal={"name"}
									setData={(e) =>
										setFilters((prev) => ({ ...prev, branchId: e }))
									}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>{Translate[lang]?.main_branch || "Main Branch"}</label>
								<Select
									value={filters?.mainBranch}
									name="mainBranch"
									placeholder={Translate[lang]?.main_branch || "Main Branch"}
									options={[
										{
											label: `${Translate[lang]?.main_branch || "Main Branch"}: ${Translate[lang]?.yes || "Yes"}`,
											value: true,
										},
										{
											label: `${Translate[lang]?.main_branch || "Main Branch"}: ${Translate[lang]?.no || "No"}`,
											value: false,
										},
									]}
									isClearable
									onChange={(e) =>
										setFilters((prev) => ({ ...prev, mainBranch: e }))
									}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>Department</label>
								<ScrollPagination
									Service={new DepartmentService()}
									value={filters?.departmentId}
									nameVal={"name"}
									setData={(e) =>
										setFilters((prev) => ({ ...prev, departmentId: e }))
									}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>Type</label>
								<Select
									options={types}
									isClearable
									value={filters?.type}
									onChange={(e) => setFilters((prev) => ({ ...prev, type: e }))}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>Date</label>
								<input
									type="date"
									className="form-control"
									value={filters?.date}
									style={{
										height: "38px",
									}}
									onChange={(e) =>
										setFilters((prev) => ({
											...prev,
											date: e.target.value,
										}))
									}
								/>
							</Col>

							<Col md={3} className="mb-3">
								<MonthDropDown
									value={filters?.month}
									changeParams={(e, key) =>
										setFilters((prev) => ({ ...prev, [key]: e }))
									}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<YearDropDown
									value={filters?.year}
									changeParams={(e, key) => {
										setFilters((prev) => ({ ...prev, [key]: e }));
									}}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>Search</label>
								<input
									type="text"
									className="form-control"
									value={filters?.search}
									style={{
										height: "38px",
									}}
									placeholder="Search by employee name or email"
									onChange={(e) =>
										setFilters((prev) => ({
											...prev,
											search: e.target.value,
										}))
									}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>Date From</label>
								<input
									type="date"
									className="form-control"
									value={filters?.dateFrom}
									style={{
										height: "38px",
									}}
									onChange={(e) =>
										setFilters((prev) => ({
											...prev,
											dateFrom: e.target.value,
										}))
									}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<label>Date To</label>
								<input
									type="date"
									className="form-control"
									value={filters?.dateTo}
									style={{
										height: "38px",
									}}
									onChange={(e) =>
										setFilters((prev) => ({
											...prev,
											dateTo: e.target.value,
										}))
									}
								/>
							</Col>
						</Row>
					</Card.Header>
				</Card>
			)}

			{selectTab === "attendance" && (
				<Card>
					<Card.Body className={`${hasData === 0 ? "text-center" : ""}`}>
						{loading && (
							<div style={{ height: "300px" }}>
								<Loader />
							</div>
						)}
						{hasData === 1 && !loading && (
							<Table responsive>
								<thead>
									<tr>
										<th className="px-2">
											<strong>I.D</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.name}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.company_email}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.branches}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.date}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.clockIn}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.clockOut}</strong>
										</th>
										<th className="px-2">
											<strong>
												{Translate[lang]?.clockIn} {Translate[lang]?.branch}
											</strong>
										</th>
										<th className="px-2">
											<strong>
												{Translate[lang]?.clockOut} {Translate[lang]?.branch}
											</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.late_minutes}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.overtime_minutes}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.early_leaving_minutes}</strong>
										</th>
										<th className="px-2">
											<strong>{Translate[lang]?.status}</strong>
										</th>
									</tr>
								</thead>
								<tbody>
									{data?.length > 0 &&
										data?.map((item, index) => {
											return (
												<CardItem
													key={index}
													index={index}
													item={item}
													setItem={setItem}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
								</tbody>
							</Table>
						)}
						{hasData === 0 && <NoData />}
						<Pagination
							setData={setData}
							service={attendanceService}
							shouldUpdate={shouldUpdate}
							setHasData={setHasData}
							setLoading={setLoading}
							setTotal={setTotal}
							search={""}
							param={params}
						/>
					</Card.Body>
				</Card>
			)}

			{selectTab === "fingerprint_settings" &&
				selectSubTab === "fingerprint_settings" && <FingerprintSettings />}
			{selectTab === "fingerprint_settings" &&
				selectSubTab === "exclude_from_fingerprint" && <FingerprintExclusion />}

			{addModal && (
				<EditAttendanceModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					item={item}
					setAddModal={() => setAddModal(false)}
				/>
			)}
			{uploadSheetModal && (
				<UploadSheetModal
					modal={uploadSheetModal}
					setModal={() => setUploadSheetModal(false)}
				/>
			)}
		</div>
	);
};
export default Attendance;
